import React from 'react';


import Product from './Product';
import styles from './Basket.module.css';


const Basket = ({ basket }) => {
  return (
    <div className={styles.menuWrapper}>
      <div className={styles.header}>
        Basket
      </div>
      <div className={styles.mainData}>
        <div className={styles.mainDataColumn}>
          {basket.meals} Meals
        </div>
        <div className={styles.mainDataColumn}>
          {basket.ingredients} Ingredients
        </div>
      </div>
      {basket.basket?.map((product, index) => (
        <Product key={index} product={product} />
      ))}
    </div>
  );
};

export default Basket;